<template>
  <div>
    <label :for="id"> {{label}}</label>
    <select v-if="!multiple" v-model="selectedValue" :id="id"  ref="pickerDocument">
      <option v-if="firstOptionMessage" value="" disabled selected>{{firstOptionMessage}}</option>
      <slot></slot>
    </select>

    <select  v-if="multiple" multiple v-model="selectedValue" :id="id"  ref="pickerDocument">
      <option v-if="firstOptionMessage" value="" disabled selected>{{firstOptionMessage}}</option>
      <slot></slot>
    </select>

    <span v-if="helpLabelText" class="helper-text" :data-error="verror" :data-success="vsuccess">{{helpLabelText}}</span>
    <div v-if="!dataSetReady" class="preloader-wrapper small active">
      <div class="spinner-layer spinner-green-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
        <div class="gap-patch">
          <div class="circle"></div>
        </div>
        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerInstance: null,
      id: null,
      selectedValue: [],
    };
  },
  props: [
    'options',
    'label',
    'value',
    'vclass',
    'verror',
    'vsuccess',
    'dataSetReady',
    'firstOptionMessage',
    'multiple',
    'helpLabelText',
  ],
  watch: {
    selectedValue(value) {
      this.$emit('input', value);
      this.$emit('touch');
      console.log('Value CHANGED', value);
    },
    value(value) {
      if (value == null || value.length === 0) {
        console.log('entro picker change selected index');
        this.pickerInstance.el.selectedIndex = 0;
        this.pickerInstance.el.selectedValue = '';
        if(dataSetReady)
          this.selectedValue = [];
      }
    },
    vclass(value) {
      console.log(value);
      if (this.pickerInstance) {
        if (value.valid) {
          this.pickerInstance.input.classList.add('valid');
          this.pickerInstance.input.classList.remove('invalid');
        } else {
          this.pickerInstance.input.classList.add('invalid');
          this.pickerInstance.input.classList.remove('valid');
        }
      }
    },
    dataSetReady() {
      const vueInstance = this;
      if (this.dataSetReady) {
        setTimeout(() => {
          vueInstance.pickerInstance = M.FormSelect.init(
            vueInstance.$refs.pickerDocument,
            vueInstance.options,
          );
        }, 200);
      } else {
        if (this.pickerInstance) this.pickerInstance.destroy();
        this.pickerInstance = null;
      }
      console.log(this.id, 'Select id');
    },
  },
  mounted() {
    this.id = `picker${this._uid}`;
    if (this.dataSetReady) {
      this.pickerInstance = M.FormSelect.init(
        this.$refs.pickerDocument,
        this.options,
      );
    }
  },
  computed: {},
};
</script>

